import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DialogRef } from '../../dialog/dialog-ref';
import { DialogConfig } from '../../dialog/dialog-config';

@Component({
    selector: 'app-click-photo',
    templateUrl: './click-photo.component.html',
    styleUrls: ['./click-photo.component.scss'],
    standalone: false
})
export class ClickPhotoComponent implements OnInit, AfterViewInit {
  photoClicked: boolean = true;
  faceImgCapture:boolean=false;
  image_data_url: any;
  _webcamList: any;
  showCameraPopUp: boolean = false;
  device: any;
  resourceName: String = "Click Photos"

  constructor(
    private modal: DialogRef,
    private util: UtilService,
    private alert: AlertsService,
    private dialog: DialogRef,
    private appService: AppService,
    private dialogConfig: DialogConfig
  ) { }

  ngOnInit(): void {
    this.getlistofCameras()
    if(this.dialogConfig !=undefined && this.dialogConfig.data !=undefined && this.dialogConfig.data.send_base64_data !=undefined && this.dialogConfig.data.send_base64_data)
      {
        this.faceImgCapture=true;
      }
  }

  ngAfterViewInit() {
    this.photoClicked = true;
    var _that = this;
    this.util.detectWebcam((res: any) => {
      if (res) {
        this.checkCameraPermission((result: any) => {
          if (result == "prompt") {
            // this.closePopup()
            _that.util.checkCameraAccessStatus()
            _that.showCameraPopUp = true;
            _that.device = "camera"
          } else if (result == "denied") {
            // this.closePopup();
            _that.util.checkCameraAccessStatus()
            _that.device = "camera"
            _that.showCameraPopUp = true;
          } else {
            this.startCamera()
          }
        })
      } else {
        this.alert.error("No camera detected")
      }
    })

  }

  getlistofCameras() {
    navigator.mediaDevices.enumerateDevices().then(getVideoInputs => {
      var mt_array = [];
      getVideoInputs.forEach(mediaDevice => {
        if (mediaDevice.kind === 'videoinput') {
          mt_array.push(mediaDevice);
        }
      });
      this._webcamList = mt_array;
    })
  }

  closedevicePopup(event: any) {
    this.closePopup()
  }

  async startCamera() {
    let video: any = document.querySelector("#video");
    let canvas: any = document.querySelector("#canvas");
    var stream: any = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
    video.srcObject = stream;
    canvas.style.display = "none";
  }

  clickPhoto() {
    let canvas: any = document.querySelector("#canvas");
    let video: any = document.querySelector("#video");
    canvas.style.display = "block";
    video.style.display = "none";
    canvas.width = video.videoWidth * window.devicePixelRatio;
    canvas.height = video.videoHeight * window.devicePixelRatio;
    canvas.style.width = `${video.videoWidth}px`;
    canvas.style.height = `${video.videoHeight}px`;
    let ctx = canvas.getContext('2d', { antialias: false });
    ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(
      video, 0, 0,
      video.videoWidth * window.devicePixelRatio,
      video.videoHeight * window.devicePixelRatio
    );
    this.image_data_url = this.dataURItoBlob(canvas.toDataURL('image/jpeg'));
    this.photoClicked = false;

     // Stop the video stream
     if (video.srcObject) {
      const stream = video.srcObject as MediaStream;
      stream.getVideoTracks().forEach(track => track.stop());
      video.srcObject = null;
    }
  }

  facePhoto(){

    const canvas: any = document.querySelector("#canvas");
    const video: any = document.querySelector("#video");
    const rectangle: any = document.querySelector("#rectangle");

    // Calculate the rectangle position and size relative to the video
    const rect = rectangle.getBoundingClientRect();
    const videoRect = video.getBoundingClientRect();

    const scaleX = video.videoWidth / videoRect.width;
    const scaleY = video.videoHeight / videoRect.height;

    const x = (rect.left - videoRect.left) * scaleX;
    const y = (rect.top - videoRect.top) * scaleY;
    const width = rect.width * scaleX;
    const height = rect.height * scaleY;

    // Set canvas size to match the rectangle size
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d', { antialias: false });
    ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;

    // Draw the rectangle area from the video onto the canvas
    ctx.drawImage(video, x, y, width, height, 0, 0, width, height);

    // Convert the canvas content to a data URL and handle it
    this.image_data_url = this.dataURItoBlob(canvas.toDataURL('image/jpeg'));
    this.photoClicked = false;

    // Display the canvas and hide the video
    canvas.style.display = "block";
    video.style.display = "none";

    // Stop the video stream
    if (video.srcObject) {
        const stream = video.srcObject as MediaStream;
        stream.getVideoTracks().forEach(track => track.stop());
        video.srcObject = null;
    }

  }

  dataURItoBlob(dataURI) {
    var byteString;
    var byteString1;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]);
      byteString1=dataURI.split(',')[1];
    } else {
      byteString = unescape(dataURI.split(',')[1]);
      byteString1=dataURI.split(',')[1];
    }
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      if(this.dialogConfig !=undefined && this.dialogConfig.data !=undefined && this.dialogConfig.data.send_base64_data !=undefined && this.dialogConfig.data.send_base64_data)
        {
         return byteString1;
        }else{
          return new Blob([ia], { type: mimeString });
        }
     
  }

correctImage() {
  this.modal.close(this.image_data_url);
}

closePopup() {
  this.dialog.close();
}

ngOnDestroy() {
  let player: any = document.querySelector("#video");
  if (player.srcObject)
    player.srcObject.getVideoTracks().forEach(track => track.stop())
}

denyImage() {
  let canvas: any = document.querySelector("#canvas");
  let video: any = document.querySelector("#video");
  canvas.style.display = "none";
  video.style.display = "block";
  this.photoClicked = true;
  this.startCamera(); // Restart the camera stream
}

checkCameraPermission(callback) {
  var that = this;
  if (this.appService.checkNativeApp() || this.util.isiOS()) {
    callback(true);
  } else {
    const permissionName = "camera" as PermissionName;
    navigator.permissions.query({ name: permissionName }).then(function (permissionStatus) {
      if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
        that.alert.error("Please give permission to access Camera");
        callback(permissionStatus.state)
      } else {
        callback(permissionStatus.state);
      }
    })
  }
}

}
